import AgentNavigation,{AgentShortcuts} from './AgentNavigation';
import {useAgentMobilePageNavigation} from '../../layout/AgentMobilePageHeader';
import AdminMobileMenu from './AdminMobileMenu';
import { AGENT_PIN_ENABLED } from '../../config/features';
import { isAgentUser } from '../../auth/loginDestination';
import { canViewAgentDashboard, canViewAgentWallet, getAdminLoginDestination } from '../../auth/loginDestination';
import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { change_Favorite, change_Total_Search } from '../../store';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import {
    LayoutDashboard, NotebookPen, CircleDollarSign, Network, Crown, ClipboardCheck, ClipboardX, ClipboardList, Siren, Users, KeyRound, Search, ChevronDown, ChevronRight, ChevronLeft, Menu, X, Banknote,
} from 'lucide-react';

import useWindowSize from '../hook/useWindowSize';

// Accordion headings toggle children; only leaf items navigate.
function MobileMenuToggle({ agent, expanded, onClick, children }) {
    return agent
        ? <button type="button" className="menu agent-menu-toggle" aria-expanded={expanded} onClick={onClick}>{children}</button>
        : <Link className="menu" onClick={onClick}>{children}</Link>;
}

function Header() {
    let location = useLocation();
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const { Rwidth, Rheight } = useWindowSize(); // 실제 훅 사용 시

    const HeaderTitle = useSelector((state) => state.HeaderTitle);
    const Favorite = useSelector((state) => state.Favorite);
    const MyData = useSelector((state) => state.MyData);
    const anthScreen = useSelector((state) => state.anthScreen);
    const brand = useSelector((state) => state.brand);
    const useLightTenantHeader =
        ["terminal", "standalone"].includes(process.env.REACT_APP_EDITION)
        || process.env.REACT_APP_BRAND_NAME === "베리타스온";
    const isFullViewportDevPage = location.pathname === '/dev/merchant-edit-preview';

    const [logoutBtn, setLogoutBtn] = useState(false);
    const [alarmBtn, setAlarmBtn] = useState(false);
    const [passwordModal, setPasswordModal] = useState(false);

    // 내부계좌 잔고 (baekma 전용)
    const [masterBalance, setMasterBalance] = useState(null);
    const [masterBalanceLoading, setMasterBalanceLoading] = useState(false);

    const fetchMasterBalance = async () => {
        if (brand?.key !== "baekma") return;
        setMasterBalanceLoading(true);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/master-balance/summary",
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMasterBalance(tmp?.data);
            }
        } catch (error) {
            console.error("내부계좌 잔고 조회 오류:", error);
        } finally {
            setMasterBalanceLoading(false);
        }
    };

    useEffect(() => {
        if (brand?.key === "baekma" && location.pathname !== "/") {
            fetchMasterBalance();
        }
    }, [brand?.key]);

    const [Favorite_List, setFavorite_List] = useState(
        Favorite?.filter((item) => item.state === 1) ?? []
    );
    useEffect(() => {
        setFavorite_List(Favorite.filter((item) => item.state === 1));
    }, [Favorite]);

    const [hamBtn, setHamBnt] = useState(false);
    const agentMenu = isAgentUser(MyData);
    const pageNavigation = useAgentMobilePageNavigation();
    const agentPageHeader = agentMenu && ['/submerchants','/integrateAgent','/agentDashboard'].includes(location.pathname);
    const pageBack = agentPageHeader ? pageNavigation?.onBack : null;
    const pageTitle = pageNavigation?.title || (location.pathname === '/submerchants' ? '가맹점 관리' : location.pathname === '/agentDashboard' ? '내 수익' : '에이전트');
    const agentProfileReturn = useRef(null);
    const openAgentProfile = (fromMenu=false) => {
        agentProfileReturn.current=fromMenu?location.pathname:null;
        setHamBnt(false);
        navigate('/agentMyPage',{state:{returnTo:location.pathname,returnToMenu:fromMenu}});
    };
    useEffect(() => {
        if(agentMenu && agentProfileReturn.current===location.pathname){
            agentProfileReturn.current=null;
            if(Rwidth<1024)setHamBnt(true);
        }
    },[agentMenu,location.pathname,Rwidth]);
    useEffect(() => {
        if (!agentMenu || !location.state?.restoreAgentMenu) return;
        if (Rwidth < 1024) setHamBnt(true);
        const {restoreAgentMenu, ...remainingState}=location.state;
        navigate(location.pathname+location.search,{replace:true,state:remainingState});
    }, [agentMenu, location.pathname, location.search, location.state, navigate, Rwidth]);
    useEffect(() => {
        if (!agentMenu || !hamBtn || Rwidth >= 1024) return;
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const escape = event => { if (event.key === 'Escape') setHamBnt(false); };
        window.addEventListener('keydown', escape);
        return () => { document.body.style.overflow = previous; window.removeEventListener('keydown', escape); };
    }, [agentMenu, hamBtn, Rwidth]);
    const [btn, setBtn] = useState([false, false, false, false, false, false]);
    const [time, setTime] = useState("");
    const [resetTime, setResetTime] = useState(false);
    const [message, setMessage] = useState("");

    const onClickBtn = (idx) => {
        let arr = [false, false, false, false, false, false];
        for (let i = 0; i < arr.length; i++) {
            if (i === idx) {
                arr[i] = !btn[i];
            } else {
                arr[i] = false;
            }
        }
        setBtn(arr);
    };

    // -------------------------
    // 로그아웃
    // -------------------------
    const onSubmit = async () => {
        if (window.confirm("로그아웃을 하시겠습니까?")) {
            onLogout();
        }
    };

    const onLogout = async () => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/admin/logout",
                {},
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                localStorage.removeItem("user");
                navigate("/");
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setMessage({ msg: "로그아웃에 실패했습니다." });
            }
            setHamBnt(false);
        } catch (error) {
            console.error(error);
        }
    };

    // -------------------------
    // 검색
    // -------------------------
    const searchInputRef = useRef(null);
    const [search, setSearch] = useState("");

    const onChangeSearch = (e) => {
        setSearch(e.target.value);
    };

    const onClickSearch = () => {
        // 예시로 총 검색 redux dispatch
        dispatch(change_Total_Search(search));
        navigate("/paylist");
    };

    // `/` 키 감지 -> 검색 포커스
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "/" && !e.shiftKey) {
                const tag = document.activeElement.tagName.toLowerCase();
                const isInputActive =
                    ["input", "textarea"].includes(tag) ||
                    document.activeElement.isContentEditable;
                if (!isInputActive) {
                    e.preventDefault();
                    searchInputRef.current?.focus();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    // -------------------------
    // 해상도 체크
    // -------------------------
    const [showSearchInput, setShowSearchInput] = useState(window.innerWidth >= 1280);
    const [windowM, setWindowM] = useState(window.innerWidth >= 768); // 768 이상 => PC, 아니면 모바일

    useEffect(() => {
        const handleResize = () => {
            setShowSearchInput(window.innerWidth >= 1280);
            setWindowM(window.innerWidth >= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // -------------------------
    // 비밀번호 변경 모달
    // -------------------------
    const PasswordModalClose = () => {
        setPasswordModal(false);
        setHamBnt(false);
        setLogoutBtn(false);
    };

    // -------------------------
    // 임시 알림 데이터
    // -------------------------
    const notifications = [
        {
            title: "수기 결제 승인",
            time: "4시간 전",
            message: "3,000,000원 수기 승인 완료",
        },
        {
            title: "수기 결제 취소 승인",
            time: "6시간 전",
            message: "1,500,000원 수기 결제 취소 완료",
        },
        {
            title: "고액 거래 승인 요청",
            time: "10시간 전",
            message: "5,000,000원 고액 거래 승인 요청",
        },
        {
            title: "고액 거래 승인 요청",
            time: "10시간 전",
            message: "5,000,000원 고액 거래 승인 요청",
        },
    ];

    // -------------------------
    // 알림 외부 클릭 => 모달 닫기
    // -------------------------
    const alarmRef = useRef(null);
    const iconRef = useRef(null); // 알림 아이콘을 감싸는 ref
    useEffect(() => {
        function handleClickOutside(e) {
            if (!alarmBtn) return; // 모달이 열려있을 때만 체크
            // alarmRef/아이콘Ref 둘다 없다면 => 바깥클릭
            if (
                alarmRef.current &&
                !alarmRef.current.contains(e.target) &&
                iconRef.current &&
                !iconRef.current.contains(e.target)
            ) {
                setAlarmBtn(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [alarmBtn]);

    // -------------------------
    // 스크롤 (알림 내용이 많을 때)
    // -------------------------
    const [isScrollable, setIsScrollable] = useState(false);
    const [atBottom, setAtBottom] = useState(false);
    const notificationsRef = useRef(null);

    useEffect(() => {
        if (alarmBtn && notificationsRef.current) {
            const el = notificationsRef.current;
            setIsScrollable(el.scrollHeight > el.clientHeight);
            setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
        }
    }, [alarmBtn]);

    const handleScroll = () => {
        if (!notificationsRef.current) return;
        const el = notificationsRef.current;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
            setAtBottom(true);
        } else {
            setAtBottom(false);
        }
    };

    return (
        <div style={{ display: location.pathname === "/" ? "none" : "" }}>
            {passwordModal && (
                <ChangePassword setModal={PasswordModalClose} setMessage={setMessage} />
            )}
            <MessageModal message={message} />

            {/* ------------------------------
            모바일 GNB (좌측 메뉴)
           ------------------------------ */}
            <div
                data-tenant-brand={process.env.REACT_APP_BRAND_NAME || ""}
                className={`mobile-menu md:hidden${agentPageHeader ? " agent-page-header" : ""} ${hamBtn ? "mobile-menu--active" : ""}`}
                style={{ zIndex: 101 }}
            >
                <div className="mobile-menu-bar">
                    {agentMenu && hamBtn && <strong className="agent-menu-heading">전체 메뉴</strong>}
                    {agentPageHeader && !hamBtn && pageBack && <button type="button" className="agent-page-back" aria-label="목록으로 돌아가기" onClick={pageBack}><ChevronLeft size={26}/></button>}
                    {agentPageHeader && !hamBtn && <h1 className="agent-page-title">{pageTitle}</h1>}
                    {(!agentPageHeader || (!hamBtn && !pageBack)) && <Link to={getAdminLoginDestination(MyData)} className="main_logo flex mr-auto gnb-link" onClick={() => setHamBnt(false)}>
                        {Rwidth >= 1280
                            ? <img src={brand.logo} alt="EC Logo" className="w-32" />
                            : <img src={brand.logoSymbol || brand.logo} alt="EC Logo" className="w-32" />
                        }
                    </Link>}
                    <ul className="header_gnb">
                        {canViewAgentDashboard(MyData, anthScreen) && <li><Link to="/agentDashboard" className="gnb-link" onClick={() => setHamBnt(false)}>내 수익</Link></li>}
                        {anthScreen.includes("거래내역") && (
                            <li>
                                <Link
                                    to={`/paylist`}
                                    className="gnb-link"
                                    onClick={() => setHamBnt(false)}
                                >
                                    거래
                                </Link>
                            </li>
                        )}
                        {canViewAgentWallet(MyData, anthScreen) && (
                            <li>
                                <Link
                                    to={`/agentWallet`}
                                    className="gnb-link"
                                    onClick={() => setHamBnt(false)}
                                >
                                    지갑
                                </Link>
                            </li>
                        )}
                        {anthScreen.includes("수기결제") && (
                            <li>
                                <Link
                                    to={`/sugiManage`}
                                    className="gnb-link"
                                    onClick={() => setHamBnt(false)}
                                >
                                    수기
                                </Link>
                            </li>
                        )}
                    </ul>

                    {/* 알림 아이콘 (모바일) */}
                    {/* <div ref={iconRef} style={{ display: "inline-block" }}>
                        <FontAwesomeIcon
                            icon={faBell}
                            style={{ color: "#fff", fontSize: "18px", cursor: "pointer", padding: "0 10px" }}
                            onClick={() => setAlarmBtn((prev) => !prev)}
                        />
                    </div> */}

                    <button
                        type="button"
                        aria-label={hamBtn ? "메뉴 닫기" : "메뉴 열기"}
                        aria-expanded={hamBtn}
                        aria-controls="admin-mobile-menu-content"
                        className={`mobile-menu-toggler${agentPageHeader ? " agent-page-menu-toggle" : ""}${agentMenu && hamBtn ? " agent-menu-close" : ""}`}
                        onClick={() => setHamBnt((e) => !e)}
                        style={{ cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                    >
                        {agentPageHeader ? (hamBtn ? <X className="agent-page-menu-icon" size={26}/> : <Menu className="agent-page-menu-icon" size={26}/>) : <>
                        {agentMenu && hamBtn && <X className="agent-close-icon" size={26} />}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24"
                            viewBox="0 0 24 24"
                            fill="none" stroke="currentColor"
                            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            icon-name="bar-chart-2" data-lucide="bar-chart-2"
                            className="lucide lucide-bar-chart-2 w-8 h-8 text-white transform -rotate-90"
                        >
                            <line x1="18" y1="20" x2="18" y2="10"></line>
                            <line x1="12" y1="20" x2="12" y2="4"></line>
                            <line x1="6" y1="20" x2="6" y2="14"></line>
                        </svg>
                        </>}
                    </button>
                </div>

                {/* 모바일 알림 모달 => alarmBtn && !windowM */}
                {/* {alarmBtn && !windowM && (
                    <div
                        ref={alarmRef}
                        className="dropdown-alarm w-56"
                        style={{
                            width: "360px",
                            height: "320px",
                            padding: "15px",
                            top: "66px",
                            right: "15px",
                            background: "#fff",
                            position: "absolute",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                fontWeight: "bold",
                                marginBottom: "10px",
                                paddingLeft: "5px",
                            }}
                        >
                            알림
                        </div>
                        <div
                            ref={notificationsRef}
                            style={{ overflowY: "auto", height: "255px" }}
                            onScroll={handleScroll}
                        >
                            {notifications.map((noti, index) => (
                                <div
                                    key={index}
                                    style={{
                                        padding: "10px",
                                        background: "#f7f7f7",
                                        borderRadius: "10px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: "8px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        <div style={{ width: "calc(100% - 90px)" }}>{noti.title}</div>
                                        <div style={{ width: "70px", textAlign: "right" }}>{noti.time}</div>
                                    </div>
                                    <div className="font-medium">{noti.message}</div>
                                </div>
                            ))}
                        </div>
                        {isScrollable && !atBottom && (
                            <div
                                className="flex flex-col items-center"
                                style={{ marginTop: "5px" }}
                            >
                                <ChevronDown
                                    className="text-gray-400 text-2xl animate-bounce"
                                    size={24}
                                    style={{ color: "#555" }}
                                />
                            </div>
                        )}
                    </div>
                )} */}

                <div className="scrollable" id="admin-mobile-menu-content">
                    <div className="menu_wrap">
                        <div className={`user_info_wrap${agentMenu ? " agent-old-profile" : ""}`}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="user_detail">
                                    {MyData?.role && <span className="user_authority">{isAgentUser(MyData) ? "영업자" : "관리자"}</span>}
                                </div>
                                <div
                                    className="user_detail"
                                    onClick={() => {
                                        setHamBnt(false);
                                        setPasswordModal(true);
                                    }}
                                >
                                    <span className="user_organization">내정보</span>
                                </div>
                            </div>
                            <div className="user_greeting">
                                <p className="user_name">{MyData?.admin_id ?? "관리자"}</p>
                                <p>님 반갑습니다.</p>
                            </div>
                        </div>
                        <hr className="separation_line" />
                        {agentMenu && <>
                            <div className="agent-menu-profile"><div><span>영업자 계정</span><strong>{MyData?.name || MyData?.admin_id || MyData?.agent_id}님</strong></div><button type="button" onClick={()=>openAgentProfile(true)}>내정보<ChevronRight size={18}/></button></div>
                            <AgentShortcuts user={MyData} screens={anthScreen} brand={brand} onNavigate={()=>setHamBnt(false)}/>
                            <h2 className="agent-menu-section-title">업무 관리</h2>
                        </>}
                        {agentMenu ? <AgentNavigation user={MyData} screens={anthScreen} brand={brand} mobile onNavigate={()=>setHamBnt(false)}/> : <AdminMobileMenu MyData={MyData} anthScreen={anthScreen} btn={btn} onClickBtn={onClickBtn} setHamBnt={setHamBnt} location={location}/>}

                    </div>
                    <div className="logout-btn">
                        <Link id="logout-admin" onClick={() => onSubmit()}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24" height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                icon-name="power"
                                data-lucide="power"
                                className="lucide lucide-power"
                            >
                                <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                                <line x1="12" y1="2" x2="12" y2="12"></line>
                            </svg>
                            <span>로그아웃</span>
                        </Link>
                    </div>
                </div>
            </div>

            {/* PC 상단 헤더 */}
            <div
                data-light-tenant-header={useLightTenantHeader ? "true" : "false"}
                data-tenant-brand={process.env.REACT_APP_BRAND_NAME || ""}
                className="top-bar-boxed h-[70px] md:h-[65px] z-[51] border-b border-white/[0.08] mt-16 md:mt-0
            -mx-3 sm:-mx-8 md:-mx-0 px-3 md:border-b-0 relative md:fixed md:inset-x-0 md:top-0
            sm:px-10 md:px-10 md:pt-15 md:bg-gradient-to-b md:from-slate-100
            md:to-transparent dark:md:from-darkmode-700"
                style={{ width: "100%", maxWidth: isFullViewportDevPage ? "none" : "1920px", margin: isFullViewportDevPage ? 0 : "0 auto", height: "52px" }}
            >
                <div className="header_wrap h-full flex items-center">
                    <div className="header_left" style={{ position: "relative" }}>
                        <Link
                            to={getAdminLoginDestination(MyData)}
                            className="logo -intro-x hidden md:flex xl:w-[180px] block"
                            style={{ }}
                        >
                            {Rwidth >= 1280
                                ? <img alt="PayK" className="logo__image w-32" src={brand.logo} />
                                : <img alt="PayK" className="logo__image w-32" src={brand.logoSymbol || brand.logo} />
                            }
                        </Link>
                        <div
                            className={`side-menu`}
                            style={{
                                padding: "0.1rem 0.1rem 0.1rem 0.5rem",
                                borderRadius: "5px",
                                backgroundColor: "#fff",
                                display: "flex",
                                position: "absolute",
                                left: showSearchInput ? "204px" : "105px",
                            }}
                        >
                            <input
                                ref={searchInputRef}
                                value={search}
                                onChange={onChangeSearch}
                                placeholder="통합검색"
                                style={{
                                    width: "125px",
                                    backgroundColor: "transparent",
                                    paddingTop: "2px",
                                    outline: "none",
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        onClickSearch();
                                    }
                                }}
                            />
                            <Search
                                size={28}
                                style={{ color: "gray", padding: "5px", cursor: "pointer" }}
                                onClick={() => onClickSearch()}
                            />
                        </div>
                    </div>

                    {/* 내부계좌 잔고 (baekma + test 계정 전용) */}
                    {brand?.key === "baekma" && MyData?.admin_id === "test" && location.pathname !== "/" && (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            fontSize: "13px",
                            color: "#fff",
                            marginLeft: "auto",
                            marginRight: "20px",
                        }}>
                            <span>내부계좌 잔고</span>
                            <span style={{ fontWeight: "bold" }}>
                                총잔액: {masterBalanceLoading ? "..." : (masterBalance?.balance ?? 0).toLocaleString()}원
                            </span>
                            <button
                                onClick={() => navigate("/payoutAccountManage")}
                                style={{
                                    padding: "3px 12px",
                                    fontSize: "12px",
                                    border: "1px solid rgba(255,255,255,0.4)",
                                    borderRadius: "4px",
                                    background: "rgba(255,255,255,0.15)",
                                    cursor: "pointer",
                                    color: "#fff",
                                }}
                            >
                                조회
                            </button>
                        </div>
                    )}

                    {/* 우측 사용자영역 */}
                    <div className="header_right intro-x">
                        <div className="user_info_wrap">
                            <div className="user_name">
                                <p>{MyData?.name}</p>
                                {MyData?.role && <span>{isAgentUser(MyData) ? "영업자" : "관리자"}</span>}
                            </div>
                        </div>

                        {/* 알림 아이콘 (PC) */}
                        {/* <div ref={iconRef} style={{ position: "relative", display: "inline-block" }}>
                            <FontAwesomeIcon
                                icon={faBell}
                                style={{ color: "#fff", fontSize: "20px", cursor: "pointer" }}
                                onClick={() => setAlarmBtn((prev) => !prev)}
                            />
                        </div> */}

                        {/* {alarmBtn && windowM && (
                            <div
                                ref={alarmRef}
                                className="dropdown-alarm"
                                style={{
                                    width: "360px",
                                    height: "320px",
                                    padding: "15px",
                                    background: "#fff",
                                    position: "absolute",
                                    top: "37px", // PC 헤더 높이에 맞춰 조정
                                    right: "85px",
                                    zIndex: 9999,
                                    borderRadius: "8px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                    }}
                                >
                                    알림
                                </div>
                                <div
                                    ref={notificationsRef}
                                    style={{ overflowY: "auto", height: "255px" }}
                                    onScroll={handleScroll}
                                >
                                    {notifications.map((noti, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                padding: "10px",
                                                background: "#f7f7f7",
                                                borderRadius: "10px",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    marginBottom: "8px",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                <div style={{ width: "calc(100% - 90px)" }}>
                                                    {noti.title}
                                                </div>
                                                <div style={{ width: "70px", textAlign: "right" }}>
                                                    {noti.time}
                                                </div>
                                            </div>
                                            <div className="font-medium">{noti.message}</div>
                                        </div>
                                    ))}
                                </div>
                                {isScrollable && !atBottom && (
                                    <div
                                        className="flex flex-col items-center"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <ChevronDown
                                            className="text-gray-400 text-2xl animate-bounce"
                                            size={24}
                                            style={{ color: "#555" }}
                                        />
                                    </div>
                                )}
                            </div>
                        )} */}

                        <div className="login_session_box" style={{ position: "relative" }}>
                            <div className="button_wrap">
                                <button id="logout-admin-pc" onClick={() => agentMenu ? openAgentProfile() : setLogoutBtn((e) => !e)}>
                                    내정보
                                </button>
                                <button id="logout-admin-pc" onClick={() => onSubmit()}>
                                    로그아웃
                                </button>
                            </div>
                            {logoutBtn && (
                                <div className="dropdown-user-info w-56" style={{ zIndex: 10000 }}>
                                    <ul className="dropdown-content bg-primary/80 before:block before:absolute before:bg-black before:inset-0 before:rounded-md before:z-[-1] text-white">
                                        <li>
                                            <Link
                                                id="logout-user"
                                                className="dropdown-item hover:bg-white/5"
                                                data-kind="pc"
                                                onClick={() => setPasswordModal((e) => !e)}
                                            >
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>비밀번호변경</div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/adminOtpDevices"
                                                className="dropdown-item hover:bg-white/5"
                                                data-kind="pc"
                                                onClick={() => setLogoutBtn(false)}
                                            >
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>OTP 기기 관리</div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export function ChangePassword({ setModal, setMessage }) {
    const MyData = useSelector((state) => { return state.MyData })
    const [formData, setFormData] = useState({
        ID: MyData?.admin_id ?? "",
        currentPw: '',
        newPw: '',
        newPwConfirm: '',
    });

    // input onChange 핸들러 (필드명(name)에 따라 업데이트)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/me/change-password", {
            currentPassword: formData.currentPw,
            newPassword: formData.newPw,
            confirmPassword: formData.newPwConfirm,
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setMessage({ msg: tmp?.msg ?? "비밀번호변경 성공" })
                setModal(false)
            }
            else {
                setMessage({ msg: tmp?.msg ?? "비밀번호변경 실패" })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabIndex="-1">
            <input type="hidden" id="event_check" value="update" />
            <div className="modal-dialog" style={{ maxWidth: "400px" }}>
                <div className="modal-content marginTop30 admin-modal-sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto">비밀번호변경</h2>
                        <div id="data_wrap">
                            <input type="hidden" id="m_code" />
                        </div>
                    </div>

                    {/* form 태그 */}
                    <form
                        id="modal-form"
                        className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className="col-span-12">
                            <label className="form-label">ID</label>
                            <input
                                id="ID"
                                name="ID"
                                type="text"
                                className="form-control input-padding"
                                placeholder=""
                                value={formData.ID}
                                disabled
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="currentPw" className="form-label">
                                현재 비밀번호
                            </label>
                            <input
                                id="currentPw"
                                name="currentPw"
                                type="password"
                                className="form-control input-padding"
                                placeholder=""
                                value={formData.currentPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPw" className="form-label">
                                새 비밀번호
                            </label>
                            <input
                                id="newPw"
                                name="newPw"
                                type="password"
                                className="form-control input-padding"
                                placeholder=""
                                value={formData.newPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPwConfirm" className="form-label">
                                새 비밀번호 확인
                            </label>
                            <input
                                id="newPwConfirm"
                                name="newPwConfirm"
                                type="password"
                                autoComplete="off"
                                className="form-control input-padding"
                                placeholder=""
                                value={formData.newPwConfirm}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button
                            id="signup-btn"
                            type="submit"
                            className="btn btn-primary"
                            onClick={onSubmit}
                        >
                            등록
                        </button>
                        <button
                            type="button"
                            data-tw-dismiss="modal"
                            className="btn btn-outline-secondary mr-1 admin-modal-btn"
                            onClick={() => setModal()}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;
